"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = matchesEntirely;

/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}
//# sourceMappingURL=matchesEntirely.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/build/helpers/matchesEntirely.js
// module id = 139
// module chunks = 0